export const NOTI_AGENT_REPORT_HANDLER_ID = "noti_agent_report_handler";
